import React from 'react';
import './Switch.css';

const Switch = ({ isOn, disabled, handleToggle, onColor, switchId }) => {
  return (
    <>
      <input
        checked={isOn}
        disabled={disabled}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={switchId}
        type="checkbox"
      />
      <label
        style={{ background: isOn && onColor }}
        className="react-switch-label"
        htmlFor={switchId}
      >
        <span className={`react-switch-button`} />
      </label>
    </>
  );
};

export default Switch;
